import { apiAxios } from '@/lib/apiAxios';
export const fetchMyInvites = async () => apiAxios.get('/users/me/invites').then((response) => response.data);
export const acceptInvite = async (invitePublicId) => apiAxios
    .post(`/users/me/invites/${invitePublicId}/accepts`)
    .then((response) => response.data);
export const declineInvite = async (invitePublicId) => apiAxios.delete(`/users/me/invites/${invitePublicId}/declines`).then((response) => response.data);
